import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

function generateRandomString() {
  try {
    let uuid = null;
    if (crypto?.randomUUID) {
      uuid = crypto.randomUUID();
    }
    return uuid || Math.random().toString(36).substring(2, 9);
  } catch (error) {
    return Math.random().toString(36).substring(2, 9);
  }
}

export const useFlowAnalyticsStore = create(
  persist(
    (set, _, store) => ({
      runFlowIds: {},
      initializeRunFlowId: (flow) => {
        set((state) => ({
          runFlowIds: {
            ...state.runFlowIds,
            [flow]: generateRandomString(),
          },
        }));
      },
      getRunFlowId: (flow) => {
        return store.getState().runFlowIds[flow] || null;
      },
      reset: (flow) => {
        if (flow) {
          set((state) => {
            const newRunFlowIds = { ...state.runFlowIds };
            delete newRunFlowIds[flow];
            return { runFlowIds: newRunFlowIds };
          });
        } else {
          set(store.getInitialState());
        }
      },
    }),
    {
      name: 'flow-analytics',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
